import { useEffect, useMemo, useState } from 'react'
import { findProjectItemWithPath, isProjectFolder } from '../ProjectItem'
import { useCurrentProjectItems } from '../ProjectManager'
import { useProjectSelection } from './useProjectSelection'

export function useProjectActiveFile() {
  const currentProjectItems = useCurrentProjectItems()

  const { selection } = useProjectSelection()
  const selectedItem = useMemo(() => {
    return selection ? findProjectItemWithPath(currentProjectItems, selection) : undefined
  }, [currentProjectItems, selection])

  const [activeFilePath, setActiveFilePath] = useState<string | null>(null)
  const activeItem = useMemo(() => {
    return activeFilePath ? findProjectItemWithPath(currentProjectItems, activeFilePath) : undefined
  }, [currentProjectItems, activeFilePath])

  const selectedItemIsFile = selectedItem && !isProjectFolder(selectedItem) ? true : false
  const activeFile = activeItem && !isProjectFolder(activeItem) ? activeItem : undefined

  useEffect(() => {
    if (selection && selectedItemIsFile && activeFilePath !== selection) {
      // update new document selection
      setActiveFilePath(selection)
    } else if (activeFilePath && !activeFile) {
      // inalidate current document selection
      setActiveFilePath(null)
    }
  }, [selection, selectedItemIsFile, activeFilePath, activeFile])

  return activeFile
}
